import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGroupPerformanceStatistics } from './queries/queries';
import GroupPerformanceWidget from '../../common/widgets/groupPerformance';
import DataProcessor from '../../common/dataProcessors/groupPerformanceDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GroupPerformance extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.allTime.groupPerformance;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  render() {
    return (
      <GroupPerformanceWidget title="All Time Group Performance" data={this.dataProcessor.data}
                              topPerformers={this.dataProcessor.topPerformers} loading={this.props.data.loading}
                              comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getGroupPerformanceStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GroupPerformance);




// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/groupPerformance.js